import React, { useState } from 'react';
import ComboTypePicker from 'components/show_drawing/redraw_form/ComboTypePicker.jsx';
import { ADMIN_DISABLED_WARNING } from 'components/show_drawing/redraw_form/combo_constants.js';
import styles from 'components/show_drawing/redraw_form/_style.module.scss';

const ComboButtonsSection = ( { combos, activeCombosByGuestName, setActiveCombosByGuestName } ) => {
  const [pickerGuestName, setPickerGuestName] = useState(null);

  if (!combos || combos.length === 0) { return null; }

  const handleClick = (group) => {
    const activeId = activeCombosByGuestName[group.guest_name];
    if (activeId) {
      setActiveCombosByGuestName((previous) => {
        const { [group.guest_name]: _removed, ...rest } = previous;
        return rest;
      });
      return;
    }
    setPickerGuestName(group.guest_name);
  };

  const pickerGroup = pickerGuestName
    ? combos.find((group) => group.guest_name === pickerGuestName)
    : null;

  return (
    <div className={styles.combo_buttons_section}>
      {combos.map((group) => {
        const activeId = activeCombosByGuestName[group.guest_name];
        const activeRelation = activeId
          ? group.relations.find((relation) => relation.id === activeId)
          : null;
        const labelKey = activeId
          ? `drawing.combo_remove_${group.guest_name}`
          : `drawing.combo_add_${group.guest_name}`;
        const showAdminWarning = activeRelation && activeRelation.enabled === false;
        return (
          <div key={group.guest_name} className={styles.combo_button_cell}>
            <button
              type="button"
              className={`btn ${activeId ? 'btn-primary' : 'btn-default'} ${styles.combo_button}`}
              data-combo-guest-name={group.guest_name}
              data-combo-active={activeId ? 'true' : 'false'}
              onClick={() => handleClick(group)}
            >
              {t(labelKey)}
            </button>
            {showAdminWarning && (
              <div className={styles.combo_admin_warning}>{ADMIN_DISABLED_WARNING}</div>
            )}
          </div>
        );
      })}

      {pickerGroup && (
        <ComboTypePicker
          group={pickerGroup}
          onSelect={(relationId) => {
            setActiveCombosByGuestName((previous) => ({
              ...previous,
              [pickerGroup.guest_name]: relationId
            }));
            setPickerGuestName(null);
          }}
          onClose={() => setPickerGuestName(null)}
        />
      )}
    </div>
  );
};

export default ComboButtonsSection;
